import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
const included = ['Dance Fitness Foundations™', 'Ready-to-Teach Class Structures™', 'Choreography Library™', 'Dance Cardio System™', 'Themed Classes™', 'Instructor Success™', 'Annual Planning System™', '100 Ready-to-Use Dance Fitness Class Ideas™', '50 Complete Dance Fitness Class Plans™', '365 Warm-Ups, Cool-Downs & Combinations™', 'Dance Fitness Monthly Challenges™', 'Professional Instructor Planner & Business Toolkit™', '7-Day Money-Back Guarantee', 'Immediate access delivered by email'];
export function FinalCTA() {
  return <section className="bg-navy px-4 py-20 text-white sm:py-24" data-id="element-90">
      <div className="mx-auto max-w-4xl" data-id="element-91">
        <header className="text-center" data-id="element-92">
          <h2 className="font-display text-3xl font-bold leading-tight sm:text-5xl" data-id="element-93">
            One last thing before you go
            <br data-id="element-94" />
            <span className="text-orange" data-id="element-95">
              Your students — and your reputation — deserve more than improvised
              classes.
            </span>
          </h2>
          <div className="mx-auto my-10 max-w-2xl space-y-3 rounded-2xl border border-white/15 bg-navy-dark p-6 text-left" data-id="element-96">
            {['Stop spending hours creating choreography from scratch every week.', 'Stop doubting whether a combination is right for the group in front of you.', 'Stop worrying about delivering enough variety, structure, and professional value.', 'Give every student a dynamic, structured class experience they deserve.', 'Give yourself the system you should have had from day one.'].map(item => <p key={item} className="flex gap-3 text-sm text-slate-100" data-id="element-97">
                <span className="text-orange" data-id="element-98">▸</span>
                {item}
              </p>)}
          </div>
          <p className="text-lg text-slate-100" data-id="element-99">
            Your classes can leave people sweating, smiling, and looking forward
            to the next one.
          </p>
          <p className="mt-2 text-xl font-bold text-orange" data-id="element-100">
            Teach with a system built for real instructors.
          </p>
        </header>

        <article className="mt-14 rounded-3xl border border-white/30 bg-navy-dark p-7 shadow-[0_18px_40px_rgba(0,0,0,.22)] sm:p-10" data-id="element-101">
          <h3 className="border-b border-white/15 pb-5 text-center font-display text-2xl font-bold" data-id="element-102">
            Everything that is included:
          </h3>
          <div className="mt-7 grid gap-x-8 gap-y-3 md:grid-cols-2" data-id="element-103">
            {included.map(item => <p key={item} className="flex items-center gap-2 text-sm text-slate-100" data-id="element-104">
                <CheckIcon size={16} className="shrink-0 text-orange" data-id="element-105" />
                {item}
              </p>)}
          </div>

          <div className="mt-9 text-center" data-id="element-106">
            <p className="rounded-xl border border-white/15 bg-white/5 p-5 text-base italic text-slate-100" data-id="element-107">
              “The system that saves you hours, helps you teach with confidence,
              and keeps every class fresh.”
            </p>
            <p className="mt-7 font-display text-xl font-bold" data-id="element-108">
              Dance Fitness Instructor Pro™
            </p>
            <p className="mx-auto mt-2 max-w-xl text-sm text-slate-300" data-id="element-109">
              Complete 7-in-1 System + 5 Premium Bonuses
            </p>
            <p className="mt-3 text-lg text-slate-200" data-id="element-110">
              <span className="line-through text-slate-400" data-id="element-111">USD 97.00</span>
              <strong className="ml-2 text-orange" data-id="element-112">Only USD 27.00</strong>
            </p>
            <CheckoutButton className="mt-7 w-full border-white sm:w-auto" data-id="element-113">
              YES, I WANT MY DANCE FITNESS INSTRUCTOR PRO™ NOW
            </CheckoutButton>
            <p className="mt-5 text-xs text-slate-300" data-id="element-114">
              Immediate access by email · ★★★★★ 4.9/5 Verified Reviews · 7-Day
              Guarantee
            </p>
          </div>
        </article>
      </div>
    </section>;
}